/**
* @author XuZiYu
* @date 2019/7/9
* @time 18:50
*/
<template>
    <div class="wrapper-pay">
        <template v-if="$route.query.headShow === '1'">
            <ctl-header title="订单支付" :onBack="goBack"/>
        </template>
        <div class="pay-info">
            <img src="@/assets/public/icon_money@2x.png" alt="">
            <p>应付金额</p>
            <p>￥<b v-if="$route.query.money">{{String($route.query.money).replace('￥','')}}</b></p>
        </div>
        <div class="pay-type">
            <div class="title">选择支付方式</div>
            <div class="type" v-for="(v,i) in payType" :key="i" @click="changePayType(v.id)">
                <div class="icon-left">
                    <img :src="v.icon" alt="">
                    <span>{{v.name}}</span>
                </div>
                <div class="icon-right">
                    <img src="@/assets/public/icon_checklist1@2x.png" alt="" v-if="typeId === v.id">
                    <img src="@/assets/public/icon_checklist2@2x.png" alt="" v-else>
                </div>
            </div>
        </div>
        <div class="btn-submit" @click="submit">
            支付
        </div>
        <ctl-dialog v-model="messageDialog"/>
    </div>
</template>

<script>
export default {
    name: 'pay',
    data () {
        return {
            type: '',
            payId: '',
            source: '',
            headShow: '',
            headHeight: 0,
            typeId: 2,
            seconds: 1800,
            setInterval: '',
            courseType: '',
            goodsCode: '',
            isOpen: false,
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            payType: [
                {
                    name: '微信支付',
                    icon: require('@/assets/public/icon_wechat_payment@2x.png'),
                    id: 2
                },
                {
                    name: '支付宝支付',
                    icon: require('@/assets/public/icon_alipay_payment@2x.png'),
                    id: 1
                }
            ]
        }
    },
    methods: {
        // 返回
        goBack () {
            if (this.type === '10') {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '确认离开',
                    leftBtnName: '继续支付',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false
                        this.$router.replace({ name: 'order', query: { headShow: this.headShow, source: this.source } })
                    },
                    title: '确认离开',
                    content: `您的订单在${parseInt(this.seconds / 60 % 60)}分钟内未支付将被取消，请尽快支付。`
                }
                return
            }

            if (this.$route.query.isOpen && this.$jsBridge.hasNativeMethod('returnLastPage')) {
                this.$jsBridge.callBackHandler('returnLastPage')
            } else {
                this.$router.back()
            }
        },
        changePayType (v) {
            this.typeId = v
        },
        submit () {
            // 题库
            if (this.type === '1') {
                // app埋点
                this.$jsBridge.callBackHandler('onEventObjectUM', { eventId: 'e_vip_pay', map: JSON.stringify({ payType: this.typeId }) })
            }

            // 套餐
            if (this.type === '8') {
                // app埋点
                this.$jsBridge.callBackHandler('onEventObjectUM', { eventId: 'e_vipp_pay', map: JSON.stringify({ payType: this.typeId }) })
            }

            // 陪驾
            if (this.type === '6') {
                // app埋点
                this.$jsBridge.callBackHandler('onEventObjectUM', { eventId: 'e_ac_order_pay', map: JSON.stringify({ payType: this.typeId }) })
            }

            // 考场视频
            if (this.type === '5') {
                // app埋点
                this.$jsBridge.callBackHandler('onEventObjectUM', { eventId: 'e_ervip_order_pay', map: JSON.stringify({ payType: this.typeId }) })
            }

            // 唤起支付
            this.$jsBridge.callBackHandler('pay', { orderId: this.payId, payWay: this.typeId, type: Number(this.type), goodsCode: this.goodsCode || '' })
        },
        payCallback (v) {
            // 支付成功 并且是 灯光仿真订单 触发埋点
            if (Number(v) === 1 && Number(this.type) === 9) {
                this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_pay_success' })
            }

            if (this.goodsCode) {
                if (Number(v) === 1) {
                    this.$jsBridge.callBackHandler('openSuccess', { goodsCode: this.goodsCode, androidType: this.isOpen ? 1 : 0 })
                }
            } else {
                this.$router.replace({ name: 'payResult',
                    query: { result: v,
                        flag: '1',
                        headShow: this.headShow,
                        type: this.type,
                        id: this.payId,
                        courseId: this.courseId,
                        source: this.source } })
            }
        }
    },
    deactivated () {
        clearInterval(this.setInterval)
    },
    created () {
        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)
        // 设置商品类型
        this.type = this.$route.query.type
        // 设置头部显示
        this.headShow = this.$route.query.headShow
        // 设置订单id
        this.payId = this.$route.query.payId
        // 设置来源
        this.source = this.$route.query.source
        // 设置课程Id
        this.courseId = this.$route.query.courseId
        // 设置商品id
        this.goodsCode = this.$route.query.goodsCode
        // 设置商品id
        this.isOpen = this.$route.query.isOpen

        if (this.type === '10') {
            // 设置定时器
            this.setInterval = setInterval(() => {
                this.seconds -= 1
                if (this.seconds <= 0) {
                    clearInterval(this.setInterval)
                    this.payCallback(2)
                }
            }, 1000)
        }
    }
}
</script>

<style scoped lang="scss">
    .wrapper-pay{
        width: 100%;
        height: 100vh;
        background: #FAFAFA;
        overflow: hidden;
        .btn-submit{
            width:345px;
            height:43px;
            background:rgba(83,203,133,1);
            border-radius:21.5px;
            font-size:17px;
            font-weight:400;
            color:rgba(255,255,255,1);
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
        }
        .pay-info{
            background: #ffffff;
            padding: 30px 0 5px;
            text-align: center;
            font-size: 0;
            img{
                width: 60px;
            }
            p:nth-child(2){
                margin-top: 20px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
            }
            p:nth-child(3){
                margin-top: 20px;
                font-weight:400;
                line-height: 1;
                color:rgba(51,51,51,1);
                padding-right: 14px;
                box-sizing: border-box;
                b{
                    margin-left: 7px;
                    font-size:50px;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                }
            }
            p:nth-child(3):first-letter{
                font-size:18px;
            }
        }
        .pay-type{
            margin-top: 10px;
            padding: 0 13.5px;
            background: #ffffff;
            img{
                width: 24px;
            }
            .title{
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                padding: 20px 0 15px;
            }
            .type{
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 0;
                line-height: 1;
                border-bottom: 1px solid #eeeeee;
                &:last-child{
                    border: 0;
                }
                .icon-left{
                    display: flex;
                    align-items: center;
                    span{
                        padding: 17.5px 0;
                        margin-left: 15px;
                        font-size:18px;
                        font-weight:400;
                        color:rgba(51,51,51,1);
                    }
                }
            }
        }
    }
</style>
